import React, { FunctionComponent, PropsWithChildren, ReactNode } from "react";
import { Box, Tooltip, Typography } from "@mui/material";

interface FieldTooltipProps {
  title?: string;
  titleNode?: ReactNode;
  placement?: "bottom" | "top" | "left" | "right";
  disableHover?: boolean;
}

const FieldTooltip: FunctionComponent<PropsWithChildren<FieldTooltipProps>> = ({
  title,
  titleNode,
  placement = "bottom",
  disableHover = false,
  children,
}) => {
  const tooltipTitle = titleNode ?? (title ? <Typography>{title}</Typography> : "");

  return (
    <Tooltip title={tooltipTitle} placement={placement} disableInteractive disableHoverListener={disableHover}>
      <Box width="100%">{children}</Box>
    </Tooltip>
  );
};

export default FieldTooltip;
